<!--
 * @Author: Junjie
 * @Date: 2022-08-24 17:28:39
 * @LastEditTime: 2023-08-29 13:30:25
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/points/modules/RelateModalForm.vue
-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form-model :model="model" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备" prop="devId">
              <j-search-select-tag
                :getPopupContainer="getModalAsContainer"
                dict="`iwt-wf`.dev_list,dev_name,id,del_flag=0 order by sort asc"
                v-model="model.devId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水流域" prop="devProcessId">
              <j-dict-select-tag
                :getPopupContainer="getModalAsContainer"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                type="list"
                v-model="model.devProcessId"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'RelateModalForm',
    components: {},
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      idType: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        model: {
          pointCode: ''
        },
        pointCodes: '',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        pointTypeData: [],
        pointTypeTree: [],
        url: {
          relateBatch: '/monitor/iotModelPoints/relateBatch'
        }
      }
    },
    methods: {
      edit (pointCodes) {
        this.model.pointCode = pointCodes
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            httpAction(this.url.relateBatch, this.model, 'put')
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      getModalAsContainer (node) {
        return document.querySelector('.j-modal-box .ant-modal-content')
      }
    }
  }
</script>
